import { render, staticRenderFns } from "./newPageFuwu.vue?vue&type=template&id=7f24a29f&scoped=true"
import script from "./newPageFuwu.vue?vue&type=script&lang=js"
export * from "./newPageFuwu.vue?vue&type=script&lang=js"
import style0 from "./newPageFuwu.vue?vue&type=style&index=0&id=7f24a29f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f24a29f",
  null
  
)

export default component.exports